import { useEffect, useState } from "react";
import { useFilter } from "../../../../hooks/useFilter";
import { format } from "date-fns";
import "../styles.css"
import axios from "../../../../services/axios"

export function InfoCattleMap() {
    const {
        areasIdsFilter,
        balanceAnimal,
        balance,
        farmFilter
    } = useFilter();
    const [areaAcreage, setAreaAcreage] = useState(0);
    const [capacityRate, setCapacityRate] = useState<number | null>(null);
    const [adjustments, setAdjustments] = useState<number | null>(null);

    useEffect(() => {
        if (areasIdsFilter.length != 0) {
            setAreaAcreage(areasIdsFilter.reduce((acc, item) => acc + item.info?.acreage, 0))
        }
    }, [areasIdsFilter]);

    useEffect(() => {
        const sumTotalUa = balanceAnimal?.reduce((acc, item) => acc + Math.abs(item.total_uas), 0)
        const capacity = sumTotalUa / areaAcreage
        if (capacityRate == null && areaAcreage != 0) {
            setCapacityRate(Number(capacity.toFixed(2)))
        }
    }, [balanceAnimal, areaAcreage, capacityRate]);

    useEffect(() => {
        setCapacityRate(null)

        const areasFilter = areasIdsFilter.length > 0 ? areasIdsFilter.map((item) => item.value) : []

        if (farmFilter) {
            axios
                .get(`/adjustments?farmId=${farmFilter?.id}&${areasFilter.length > 0 ? areasFilter.map(area => `areaIds=${area}`).join("&") : ""}`)
                .then(({ data }) => {
                    setAdjustments(data.reduce((sum: number, adjustment: any) => sum + adjustment.balance, 0));
                })
        }
    }, [farmFilter, areasIdsFilter]);

    // Calcular balanceTotal a partir do balance do context
    const balanceTotal = balance?.reduce((acc, item) => acc + item.end_balance, 0) || 0;

    return (
        <section className="dashBoardInfo__container" style={{ marginTop: 30 }}>
            {/* <div className="dashBoardInfo__owner--container">
                <small>Saldo inicial</small>
                <h6>{balance?.reduce((acc, item) => acc + item.opening_balance, 0)}</h6>
            </div>

            <div style={{ display: "flex", gap: 10 }}>
                <div className="dashBoardInfoSplited__owner--container">
                    <small>Nascimentos</small>
                    <h6>+{balance?.reduce((acc, item) => acc + item.birth, 0)}</h6>
                </div>
                <div className="dashBoardInfoSplited__owner--container">
                    <small>Mortes</small>
                    <h6>{balance?.reduce((acc, item) => acc + item.death, 0)}</h6>
                </div>
            </div>

            <div style={{ display: "flex", gap: 10 }}>
                <div className="dashBoardInfoSplited__owner--container">
                    <small>Compras</small>
                    <h6>+{balance?.reduce((acc, item) => acc + item.shopping, 0)}</h6>
                </div>
                <div className="dashBoardInfoSplited__owner--container">
                    <small>Vendas</small>
                    <h6>{balance?.reduce((acc, item) => acc + item.sales, 0)}</h6>
                </div>
            </div> */}

            <div className="dashBoardInfoSplited__owner--container">
                <small>Ajuste atual</small>
                <h6 className={adjustments && adjustments <= 0 ? "dashBoardAdjustment__negative" : "dashBoardAdjustment__positive"}>{adjustments || 0}</h6>
            </div>

            <div className="dashBoardInfo__dark--container">
                <small>Saldo previsto</small>
                <h6>{balanceTotal - (adjustments || 0)}</h6>
            </div>

            <div className="dashBoardInfoGreen__owner--container">
                <small>lotação (ua/ha)</small>
                <h6>{capacityRate || 0}</h6>
            </div>
        </section>
    );
}